import React, {useContext} from 'react';
import {Redirect, Route, RouteProps, Switch, useLocation} from "react-router-dom";
import Login from "./components/Login";
import Consents from "./components/Consents";
import PrintersTab from "./components/PrintersTab";
import Settings from "./components/Settings";
import LocationsTab from "./components/LocationsTab";
import AddEditLocation from "./components/modals/AddEditLocation";
import PrinterDetails from "./components/PrinterDetails";
import DeleteLocation from "./components/modals/DeleteLocation";
import DeletePrinter from "./components/modals/DeletePrinter";
import {SessionContext} from "./components/SessionContext";
import {useModalBackground} from "./commons/ModalHelpers";
import Reports from "./components/Reports";
import GenerateReport from "./components/modals/GenerateReport";
import AddEditDistribution from "./components/modals/AddEditDistribution";
import DeleteDistribution from "./components/modals/DeleteDistribution";
import ReportModalErrorBoundary from "./components/ReportModalErrorBoundary";
import UsersTab from "./components/UsersTab";
import AddEditUser from "./components/modals/AddEditUser";
import DeleteUser from "./components/modals/DeleteUser";
import ResetUserPassword from "./components/modals/ResetUserPassword";
import SetPassword from "./components/SetPassword";
import Terms from "./components/legal/Terms";
import PrivacyPolicy from "./components/legal/PrivacyPolicy";

const GenerateReportBoundary = (props) => <ReportModalErrorBoundary title="Nie udało się otworzyć formularza raportu">
    <GenerateReport {...props} />
</ReportModalErrorBoundary>;

const AddEditDistributionBoundary = (props) => <ReportModalErrorBoundary title="Nie udało się otworzyć dystrybucji raportu">
    <AddEditDistribution {...props} />
</ReportModalErrorBoundary>;

const DeleteDistributionBoundary = (props) => <ReportModalErrorBoundary title="Nie udało się otworzyć okna usuwania dystrybucji">
    <DeleteDistribution {...props} />
</ReportModalErrorBoundary>;

const Routes = (props: RouteProps) => {

    const location = useLocation();
    const background = useModalBackground();

    return <>
        {background?
            <Switch>
                <PrivateRoute path={AddEditLocation.url} component={AddEditLocation}/>
                <PrivateRoute path={DeleteLocation.url} component={DeleteLocation}/>
                <PrivateRoute path={DeletePrinter.url} component={DeletePrinter}/>
                <PrivateRoute path={GenerateReport.url} component={GenerateReportBoundary}/>
                <PrivateRoute path={AddEditDistribution.url} component={AddEditDistributionBoundary}/>
                <PrivateRoute path={DeleteDistribution.url} component={DeleteDistributionBoundary}/>
                <PrivateRoute path={AddEditUser.url} component={AddEditUser}/>
                <PrivateRoute path={DeleteUser.url} component={DeleteUser}/>
                <PrivateRoute path={ResetUserPassword.url} component={ResetUserPassword}/>
            </Switch>
            : null
        }
        <Switch location={background || location}>
            <Route path="/" exact>
                <Redirect to={PrintersTab.url} from="/" push={true}/>
            </Route>
            <Route path={Login.url} component={Login} />
            <Route path={Consents.url} exact component={Consents}/>
            {/* publiczna - ustawienie hasła z linku nie wymaga zalogowania */}
            <Route path={SetPassword.url} component={SetPassword}/>
            {/* publiczne - dokumenty prawne muszą być dostępne przed zalogowaniem */}
            <Route path={Terms.url} exact component={Terms}/>
            <Route path={PrivacyPolicy.url} exact component={PrivacyPolicy}/>
            <PrivateRoute path={PrintersTab.url} exact component={PrintersTab}/>
            <PrivateRoute path={Settings.url} exact component={Settings}/>
            <PrivateRoute path={LocationsTab.url} exact component={LocationsTab}/>
            <PrivateRoute path={UsersTab.url} exact component={UsersTab}/>
            <PrivateRoute path={Reports.url} component={Reports}/>
            <PrivateRoute path={PrinterDetails.url} exact component={PrinterDetails}/>
            <Route path="*" component={ErrorScreen}/>
        </Switch>
    </>
}

export default Routes;

const PrivateRoute = (props) => {
    const context = useContext(SessionContext);
    if (context.logged) return <Route {...props} />
    return <Redirect to={{ pathname: Login.url, state: { from: props.location } }} />
}

const ErrorScreen = (props: RouteComponentProps) => {
    return <h1>Błąd nie znaleziono: "{props.location.pathname}"</h1>;
}